import React, { Fragment, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { EiqPagination } from 'eiq-storybook';
import Loader from 'src/components/Loader';
import { Trans } from 'react-i18next';
import { makeJobUrl } from 'src/routes/routes';
import { toSimpleUtcDateString } from 'src/utils/format/date';
import { toCamel } from 'src/utils/core/word';
import { useData } from './hooks';
import s from '../Dashboards.styles';

export const UserDashboardSaqJobWidget = () => {
  const {
    Saqjobs,
    SaqjobsLoading,
    totalSAQJobs,
    reFetchNextSAQJobsBatch,
  } = useData();

  const [SAQJobsOffsetMovedBy, setSAQJobsOffsetMovedBy] = useState(0);
  const [SAQJobPageCounter, setSAQJobPageCounter] = useState(1);

  const SAQJobsPrevInactive = SAQJobsOffsetMovedBy === 0 || totalSAQJobs === 0;
  const SAQJobsNextInactive =
    SAQJobsOffsetMovedBy + Saqjobs.length === totalSAQJobs ||
    totalSAQJobs === 0;

  const SaqJobsWidgetDivFunc = () => {
    if (!Saqjobs || Saqjobs.length === 0) {
      return null;
    }

    return (
      <s.SaqJobsWidgetDiv>
        <ReactTooltip id="UserDashboardSaqJobWidget" place="right" />
        {Saqjobs.map(Saqjob => {
          return (
            <s.WidgetCard key={Saqjob.jobId}>
              <s.WidgetCardInnerDiv>
                <s.JobName to={makeJobUrl(Saqjob.jobId)}>
                  {Saqjob.reportNumber}
                </s.JobName>
                <s.FactoryName>{Saqjob.factoryName}</s.FactoryName>
                {!Saqjob.reviewerId && (
                  <s.JobStatusSpan >
                    <Trans>{Saqjob.status.toUpperCase()}</Trans>
                  </s.JobStatusSpan>
                )}
                {Saqjob.actionRequired && (
                  <s.JobStatusSpan actionRequired={true}>
                    <Trans>AUDITOR_DASHBOARD_ACTION_REQUIRED</Trans>
                  </s.JobStatusSpan>
                )}
                <s.CardInfoWithMargin>
                  <s.ServicesName
                    data-for="ReportReviewerDashboardWidget"
                    data-tip={
                      Saqjob.serviceNames && Saqjob.serviceNames.length > 0
                        ? Saqjob.serviceNames.join(', ')
                        : 'N/A'
                    }
                  >
                    <s.ServiceButtonBookIcon name="serviceIconBlue" />
                    {Saqjob.serviceNames && Saqjob.serviceNames.length > 0
                      ? Saqjob.serviceNames.join(', ')
                      : 'N/A'}
                  </s.ServicesName>
                </s.CardInfoWithMargin>
                <s.DateAndAssignedTo>
                  <s.DateAndAssignedToLeft>
                    <s.CardSmallTitle>
                      <Trans>SAQ_DATE</Trans>
                    </s.CardSmallTitle>
                    <s.CardSmallValue
                      data-for="ReportReviewerDashboardWidget"
                      data-tip={`${toSimpleUtcDateString(Saqjob.auditStartAt)}`}
                    >
                      <s.AuditStartDate>
                        {toSimpleUtcDateString(Saqjob.auditStartAt)}
                      </s.AuditStartDate>
                    </s.CardSmallValue>
                  </s.DateAndAssignedToLeft>
                  <s.DateAndAssignedToRight>
                    {
                      <Fragment>
                        <s.CardSmallTitle>
                          <Trans>AUDITOR_DASHBOARD_ASSIGNED_TO</Trans>
                        </s.CardSmallTitle>
                        <s.CardSmallValue
                          data-for="ReportReviewerDashboardWidget"
                          data-tip={
                            Saqjob.auditorNames.length === 0
                              ? 'N/A'
                              : Saqjob.auditorNames.join(', ')
                          }
                        >
                          {Saqjob.auditorNames.length === 0
                            ? 'N/A'
                            : Saqjob.auditorNames.join(', ')}
                        </s.CardSmallValue>
                      </Fragment>
                    }
                  </s.DateAndAssignedToRight>
                </s.DateAndAssignedTo>
              </s.WidgetCardInnerDiv>
            </s.WidgetCard>
          );
        })}
        <s.CornerNavigationContainer>
          <EiqPagination
            dataCount={totalSAQJobs}
            showPerPage={false}
            pageSize={18}
            canPreviousPage={!SAQJobsPrevInactive}
            canNextPage={!SAQJobsNextInactive}
            pageIndex={SAQJobPageCounter - 1}
            gotoPage={pageIndex => {
              const newCountOfSAQJobsOffset = pageIndex * 18;
              setSAQJobsOffsetMovedBy(newCountOfSAQJobsOffset);
              reFetchNextSAQJobsBatch(newCountOfSAQJobsOffset);
              setSAQJobPageCounter(pageIndex + 1);
            }}
            nextPage={() => {
              if (SAQJobsNextInactive) {
                return;
              }
              const newCountOfSAQJobsOffset = SAQJobsOffsetMovedBy + 18;
              setSAQJobsOffsetMovedBy(newCountOfSAQJobsOffset);
              reFetchNextSAQJobsBatch(newCountOfSAQJobsOffset);
              setSAQJobPageCounter(SAQJobPageCounter + 1);
            }}
            previousPage={() => {
              if (SAQJobsPrevInactive) {
                return;
              }
              const newCountOfSAQJobsOffset = SAQJobsOffsetMovedBy - 18;
              setSAQJobsOffsetMovedBy(newCountOfSAQJobsOffset);
              reFetchNextSAQJobsBatch(newCountOfSAQJobsOffset);
              setSAQJobPageCounter(SAQJobPageCounter - 1);
            }}
          />
        </s.CornerNavigationContainer>
      </s.SaqJobsWidgetDiv>
    );
  };

  return (
    <Fragment>
      <s.DashboardComponent>
        <s.DashboardComponentTitle widget>
          <Trans>SAQ_SELF_QUESTIONNAIRES_TITLE</Trans>
        </s.DashboardComponentTitle>
        {SaqjobsLoading ? <Loader /> : SaqJobsWidgetDivFunc()}
      </s.DashboardComponent>
    </Fragment>
  );
};

export default React.memo(UserDashboardSaqJobWidget);
